export default __webpack_public_path__ + "static/me-0b8aab7429c1a51c4ccb76809208b5f7.jpg";